module.exports = __webpack_public_path__ + "static/five-stars-fc21705cdcdab0c4e7369e1b0ed5987f.jpg";